import { ToastContainer, toast } from 'react-toastify';

import React, { useState, useEffect } from "react";
import downArrow from "../assets/downArrow.png";
import checkoutBg from "../assets/checkoutbg.png";
import api from '../utils/api';
import { useAuth } from '../context/AuthContext'; // Import useAuth for token
import { useUser } from '../context/UserContext'; // Import the user context
import CashbackComponent from './CashbackComponent';
import GrandTotalComponent from "./GrandTotalComponent"; // Adjust the path as needed
import convertToUSD from '../utils/currencyConverter';
import { exchangeRates } from "../utils/currencyConverter"; // Adjust the path to match your project structure
import PS2 from "../assets/pxcheck.png";
import Login from './Login';
import Register from './Register';
import CryptoJS from 'crypto-js';
import giftemoji from "../assets/giftemoji.png";
import { Info } from "lucide-react"
import XboxBuy from "../assets/mobPsComp.png";




const getCurrencySymbol = (currency) => {
  const symbols = {
    USD: "$",
    EUR: "€",
    GBP: "£",
    PKR: "₨",
    INR: "₹",
    CAD: "C$",
    SAR: "SAR", // Added symbol for SAR
  };

  return symbols[currency] || currency; // Fallback to showing the currency code if symbol not found
};



const PSCheckout = ({ quantity, amount, cashback, currency, gatewayFees }) => {
  const [isNewCustomer, setIsNewCustomer] = useState(false);
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [showRegisterPopup, setShowRegisterPopup] = useState(false);

  const toggleLoginPopup = () => setShowLoginPopup(!showLoginPopup);
  const toggleRegisterPopup = () => setShowRegisterPopup(!showRegisterPopup);

  const currencySymbol = getCurrencySymbol(currency); // Get the symbol for the current currency
  const [referralCodeStatus, setReferralCodeStatus] = useState(null); // { valid: boolean, message: string }

  const [grandTotalInUSD, setGrandTotalInUSD] = useState(amount); // Temporary state for grand total in USD
  const [cashBackUsd, setcashBackUsd] = useState(cashback);
  const [isSaveDetailsChecked, setIsSaveDetailsChecked] = useState(false); // State for checkbox
  const [walletEnabled, setWalletEnabled] = useState(false);
  const [saveDetails, setSaveDetails] = useState(false)
  const [agreeTerms, setAgreeTerms] = useState(false)

  const [userId, setUserId] = useState(null); // State to store user ID
  const { token: authToken } = useAuth(); // Access the token from AuthContext
  const [isDiscountApplied, setIsDiscountApplied] = useState(false); // Track if discount is applied
  const [referralDiscount, setReferralDiscount] = useState(0); // For referral discount
  const [referralCodeApplied, setReferralCodeApplied] = useState(false); // To track if referral code has been applied
  const [grandTotal, setGrandTotal] = useState(amount + gatewayFees);
  const [cashbackEarned, setCashbackEarned] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [isCashbackEnabled, setIsCashbackEnabled] = useState(false);
  const [walletAmount, setWalletAmount] = useState(0); // State to store wallet amount
  // referal code
  const [isValidatingReferral, setIsValidatingReferral] = useState(false);
  const [userData, setUserData] = useState(null); // Add this state
  const [initialGrandTotal, setInitialGrandTotal] = useState(grandTotal);

  const maxWalletBySubtotal = Math.min(
    (amount - discount) * 0.10,
    walletAmount
  );


  useEffect(() => {
    // Convert cashback to USD when the component mounts or when currency or cashback changes
    const convertedCashback = convertToUSD(currency, cashback);
    setcashBackUsd(convertedCashback);
  }, [currency, cashback]);


  useEffect(() => {
    const fetchUserId = async () => {
      if (!authToken) return; // Skip fetching user ID if no token is available

      try {
        const response = await api.get(`${process.env.REACT_APP_API_BASE_URL}/users/me`, {
          headers: {
            Authorization: `Bearer ${authToken}`, // Use the token for authorization
          },
        });

        const userData = response.data;
        if (userData?._id) {
          setUserId(userData._id); // Set the user ID in state
          console.log("User ID:", userData._id); // Log the user ID
        } else {
          console.error("User ID not found in response.");
        }
      } catch (error) {
        console.error("Error fetching user ID:", error);
        toast.error("Failed to fetch user information.");
      }
    };

    fetchUserId();
  }, [authToken]);



  useEffect(() => {
    const fetchUserData = async () => {
      if (!authToken) return;

      try {
        const response = await api.get(`${process.env.REACT_APP_API_BASE_URL}/users/me`, {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });

        const userData = response.data;
        if (userData?._id) {
          setUserId(userData._id);
          setUserData(userData); // Store the complete user data
          setFormData(prev => ({
            ...prev,
            contactEmail: userData.email // Set email from userData
          }));
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchUserData();
  }, [authToken]);


  const [formData, setFormData] = useState({
    backupCode1: "",
    contactEmail: authToken ? userData?.email : "", // Use email from userData
    discountCode: "",
    referralCode: "", // New field for referral code
    orderType: "buy", // Default to 'buy'
    originEmail: "",
    originPassword: "",
    type: "PS", // Default type
    price: amount, // Amount from props
    quantity: Math.round(quantity * 1.1),
    cashBack: cashBackUsd, // Cashback from props
    walletUsed: 0,
    currency: currency,
  });

  useEffect(() => {
    // Convert cashback to USD when the component mounts or when currency or cashback changes
    const convertedCashback = convertToUSD(currency, cashback);
    setcashBackUsd(convertedCashback);
  }, [currency, cashback]);



  useEffect(() => {
    // Update formData with the updated cashBackUsd
    setFormData((prevFormData) => ({
      ...prevFormData,
      cashBack: cashBackUsd, // Set converted cashback in formData
    }));
  }, [cashBackUsd]);



  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const referralCode = urlParams.get('referralCode');

    if (referralCode && !referralCodeApplied) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        referralCode,
      }));

      // Automatically validate the referral code
      validateReferralCode(referralCode);
    }
  }, [referralCodeApplied]); // Only re-run if `referralCodeApplied` changes




  const handleDiscountApply = async () => {
    if (isDiscountApplied) {
      toast.error("Discount code has already been applied.");
      return;
    }

    try {
      const response = await api.get(`${process.env.REACT_APP_API_BASE_URL}/coupons`);
      const coupons = response.data;

      const coupon = coupons.find(
        (c) => c.couponCode === formData.discountCode && c.status === "active"
      );

      if (coupon) {
        console.log("formData.type:", formData.type);
        console.log("coupon.type:", coupon.type);

        // If coupon.type is "all", apply the discount regardless of formData.type
        if (coupon.type === "all" || formData.type === coupon.type) {
          const discountValue = parseFloat(((coupon.discountPercentage / 100) * amount).toFixed(2));
          console.log("Discount Value:", discountValue);

          if (!discountValue || isNaN(discountValue)) {
            toast.error("Invalid discount value.");
            return;
          }

          setFormData((prevData) => ({
            ...prevData,
            OrderDiscountValue: discountValue,
          }));

          setGrandTotal((prevGrandTotal) => parseFloat((prevGrandTotal - discountValue).toFixed(2))); // Update grand total
          setDiscount(discountValue);
          setIsDiscountApplied(true);

          toast.success(`Discount code applied! You saved ${discountValue.toFixed(2)}.`);
        } else {
          // Display an error message if coupon.type does not match formData.type
          toast.error(`This discount code is only valid for ${coupon.type}.`);
        }
      } else {
        toast.error("Invalid or inactive discount code.");
        setFormData((prevData) => ({
          ...prevData,
          discountCode: "",
        }));
      }
    } catch (error) {
      console.error("Error fetching coupons:", error);
      toast.error("Failed to apply discount code.");
    }
  };






  const validateReferralCode = async (code = formData.referralCode) => {
    if (!code) {
      toast.error("Please enter a referral code.");
      return;
    }

    setIsValidatingReferral(true); // Prevent further calls while validating

    try {
      // Fetch userId if not already set
      let userIdToUse = userId; // Use existing userId if available
      if (!userId) {
        const response = await api.get(`${process.env.REACT_APP_API_BASE_URL}/users/me`, {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });

        const userData = response.data;
        if (userData?._id) {
          userIdToUse = userData._id; // Assign the fetched userId
          setUserId(userData._id); // Save to state for future use
        } else {
          throw new Error("Failed to fetch user ID.");
        }
      }

      // Send referral code validation request
      const validationResponse = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/generate-affiliate-code/validate/${code}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ userId: userIdToUse }), // Include the fetched or existing userId
        }
      );

      const data = await validationResponse.json();
      if (data.valid) {
        const discountPercentage = data.discountPercentage || 0;

        // Calculate and apply the referral discount
        const discountValue = parseFloat(((discountPercentage / 100) * grandTotal).toFixed(2));
        setGrandTotal((prevGrandTotal) =>
          parseFloat((prevGrandTotal - discountValue).toFixed(2))
        );

        setReferralDiscount(discountValue);
        setReferralCodeApplied(true);

        setFormData((prevFormData) => ({
          ...prevFormData,
          referralCode: code,
        }));

        toast.success(`Referral code applied!.`);
      } else {
        toast.error(data.message || "Invalid referral code.");
      }
    } catch (error) {
      console.error("Error validating referral code:", error);
      toast.error("SIgn in to use this referral code.");
    } finally {
      setIsValidatingReferral(false); // Reset validation state
    }
  };




  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Update the form data state
    setFormData((prev) => ({
      ...prev,
      [name]: name === "discountCode" ? value.toUpperCase() : value,
    }));

    // Save only specific fields to localStorage
    const fieldsToSave = {
      contactEmail: formData.contactEmail,
      originEmail: formData.originEmail,
      originPassword: formData.originPassword,
      backupCode1: formData.backupCode1,
      // referralCode: formData.referralCode, // Add referral code to fields to save
    };

    // Get the current formData and update the relevant fields
    const updatedData = {
      ...fieldsToSave,
      ...JSON.parse(localStorage.getItem("formData") || "{}"),
      [name]: value,
    };

    // Save updated data to localStorage
    localStorage.setItem("formData", JSON.stringify(updatedData));

    // Reset referral code validation status when referralCode is updated
    if (name === "referralCode") {
      setReferralCodeStatus({ valid: false, message: "" });
    }
  };


  useEffect(() => {
    // Recalculate grandTotalInUSD whenever grandTotal or currency changes
    const convertGrandTotal = () => {
      try {
        const convertedAmount = convertToUSD(currency, grandTotal);
        setGrandTotalInUSD(convertedAmount);
      } catch (error) {
        console.error("Error converting grand total to USD:", error);
      }
    };

    convertGrandTotal();
  }, [grandTotal, currency]); // Dependency on grandTotal and currency ensures updates


  useEffect(() => {
    const savedData = JSON.parse(localStorage.getItem("formData"));
    if (savedData) {
      const { discountCode, ...rest } = savedData; // exclude discountCode
      setFormData((prev) => ({
        ...prev,
        ...rest,
      }));
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      console.log("Starting Stripe checkout with formData:", formData);

      let referralDiscountValue = 0;

      // Skip referral code validation if already applied
      if (referralCodeApplied) {
        console.log("Referral code already applied. Skipping validation.");
        referralDiscountValue = referralDiscount; // Use the discount already applied
      } else if (formData.referralCode) {
        // Validate referral code if not already applied
        try {
          const validationResponse = await api.get(
            `${process.env.REACT_APP_API_BASE_URL}/api/generate-affiliate-code/validate/${formData.referralCode}`
          );

          if (!validationResponse.data.valid) {
            toast.error("Invalid referral code. Please check and try again.");
            return; // Stop submission if referral code is invalid
          }

          console.log("Referral code is valid:", formData.referralCode);

          // Calculate referral discount if discountPercentage is available
          const { discountPercentage } = validationResponse.data;
          if (discountPercentage) {
            referralDiscountValue = parseFloat(
              ((discountPercentage / 100) * grandTotal).toFixed(2)
            );
            console.log(`Referral discount value: ${referralDiscountValue}`);
            setGrandTotal((prevGrandTotal) =>
              parseFloat((prevGrandTotal - referralDiscountValue).toFixed(2))
            );
          }
        } catch (validationError) {
          console.error("Error validating referral code:", validationError);
          toast.error("Failed to validate referral code. Please try again.");
          return;
        }
      }

      // Convert wallet amount to USD and calculate the wallet deduction
      const walletToDeductUSD = formData.walletUsed / (exchangeRates[currency] || 1); // Convert walletUsed to USD
      const cashbackInUSD = cashBackUsd; // Cashback already in USD

      // Calculate the updated wallet balance in USD
      const currentWalletInUSD = walletAmount / (exchangeRates[currency] || 1);
      const newWalletAmountInUSD =
        currentWalletInUSD - walletToDeductUSD + cashbackInUSD;

      // Calculate the updated grand total in USD
      const updatedGrandTotal = grandTotalInUSD - walletToDeductUSD;

      // Prepare the data for Stripe Checkout
      const stripeCheckoutData = {
        amount: grandTotalInUSD, // Payment amount in USD
        metadata: {
          ...formData, // Include all form data in metadata
          walletUsed: walletToDeductUSD, // Wallet used in USD
          userId: userId || null, // Include user ID if available
          contactEmail: formData.contactEmail, // Pass contactEmail explicitly
          currency: formData.currency, // Regional currency (e.g., GBP, EUR)
          referralCode: formData.referralCode || "", // Include referral code if provided
          referralDiscountValue, // Include referral discount value in metadata
        },
      };

      console.log("Sending data to create Stripe Checkout session:", stripeCheckoutData);

      const generateHmacSignature = (payload) => {
        const secretKey = "d4f1c6a84b1fbc47e39c489bf5f735e57e0ddcb4683f1f7a59d7c987a3e4d258"

        if (!secretKey) {
          throw new Error("API secret key is not defined.");
        }

        const timestamp = Date.now().toString();
        const message = `${timestamp}${JSON.stringify(payload)}`;
        const signature = CryptoJS.HmacSHA256(message, secretKey).toString(CryptoJS.enc.Hex);

        return { timestamp, signature };
      };

      const { timestamp, signature } = generateHmacSignature(stripeCheckoutData);

      const headers = {
        Authorization: authToken ? `Bearer ${authToken}` : '',
        'x-timestamp': timestamp,
        'x-signature': signature,
        'Content-Type': 'application/json'
      };

      const response = await api.post(
        `${process.env.REACT_APP_API_BASE_URL}/checkout/create-checkout-session`,
        stripeCheckoutData,
        { headers }
      );


      // Redirect to Stripe Checkout
      if (response.data.url) {
        window.location.href = response.data.url; // Redirect to Stripe's checkout page
      } else {
        toast.error("Failed to initiate Stripe checkout. Please try again.");
      }
    } catch (error) {
      console.error("Error initiating Stripe checkout:", error);

      // Handle errors gracefully
      toast.error(
        error.response?.data?.error ||
        "Failed to initiate Stripe checkout. Please try again."
      );
    }
  };



  const handleCheckout = async (e) => {
    e.preventDefault();

    try {
      console.log("Starting checkout with formData:", formData);

      // Convert wallet amount to USD and calculate the wallet deductio
      // Prepare the form data to send to the backend for Stripe Checkout
      const checkoutData = {
        amount: grandTotalInUSD, // Total amount in USD

      };

      console.log("Checkout data being sent to backend:", checkoutData);

      const headers = authToken ? { Authorization: `Bearer ${authToken}` } : {};

      // Initiate Stripe Checkout
      const response = await api.post(
        `${process.env.REACT_APP_API_BASE_URL}/checkout/create-checkout-session`,
        checkoutData,
        { headers }
      );

      console.log("Stripe Checkout session created successfully:", response.data);

      // Redirect using Stripe's provided URL
      if (response.data.url) {
        console.log("Redirecting to Stripe Checkout URL:", response.data.url);
        window.location.href = response.data.url; // Use the session URL directly
      } else {
        toast.error("Failed to initiate payment. Please try again.");
      }
    } catch (error) {
      console.error("Error during Stripe checkout:", error);

      // Handle specific backend errors
      if (error.response && error.response.data) {
        toast.error(error.response.data.error || "Failed to initiate payment. Please try again.");
      } else {
        toast.error("Failed to initiate payment. Please check your connection and try again.");
      }
    }
  };



  useEffect(() => {
    const exchangeRates = {
      USD: 1,        // Base currency
      EUR: 0.92,     // Example rate for Euro
      GBP: 0.78,     // Example rate for British Pound
      INR: 83.00,    // Example rate for Indian Rupee
      AUD: 1.61,     // Example rate for Australian Dollar
      CAD: 1.35,     // Example rate for Canadian Dollar
      JPY: 148.50,   // Example rate for Japanese Yen
      PKR: 280,
      SAR: 3.75,     // Example rate for Saudi Riyal

    };

    const fetchWalletAmount = async () => {
      if (!authToken) return; // Skip fetching wallet amount if not logged in

      try {
        const response = await api.get(`${process.env.REACT_APP_API_BASE_URL}/users/me`, {
          headers: { Authorization: `Bearer ${authToken}` },
        });

        if (response.data?.wallet) {
          const walletInUSD = response.data.wallet;

          // Convert the wallet amount to the user's local currency using hardcoded rates
          const conversionRate = exchangeRates[currency] || 1; // Default to USD if currency not found
          const convertedWalletAmount = walletInUSD * conversionRate;

          setWalletAmount(convertedWalletAmount); // Update wallet amount with converted value
        } else {
          console.error("Wallet amount not found in response.");
        }
      } catch (error) {
        console.error("Error fetching wallet amount:", error);
      }
    };

    fetchWalletAmount();
  }, [authToken, currency]); // Re-run when authToken or currency changes


  useEffect(() => {
    // Convert grandTotal to USD using hardcoded exchange rates
    const convertGrandTotal = () => {
      if (currency === "USD") {
        setGrandTotalInUSD(amount); // No conversion needed if currency is already USD
      } else {
        try {
          const convertedAmount = convertToUSD(currency, amount); // Use hardcoded rates
          setGrandTotalInUSD(convertedAmount);
        } catch (error) {
          console.error(error.message); // Log unsupported currency error
        }
      }
    };

    convertGrandTotal();
  }, [amount, currency]);

  const handleSaveDetailsChange = () => {
    setIsSaveDetailsChecked((prevChecked) => {
      const newChecked = !prevChecked;

      if (newChecked) {
        // Filter only the specific fields to save
        const fieldsToSave = {
          contactEmail: formData.contactEmail,
          originEmail: formData.originEmail,
          originPassword: formData.originPassword,
          backupCode1: formData.backupCode1,
        };

        // Save filtered fields to localStorage
        localStorage.setItem("formData", JSON.stringify(fieldsToSave));
        localStorage.setItem("isSaveDetailsChecked", "true");
      } else {
        // Remove data from localStorage
        localStorage.removeItem("formData");
        localStorage.setItem("isSaveDetailsChecked", "false");
      }

      return newChecked;
    });
  };

  useEffect(() => {
    const checkIfNewCustomer = async () => {
      if (!userId) {
        console.log('No userId, setting isNewCustomer to false');
        setIsNewCustomer(false);
        return;
      }

      try {
        console.log('Checking order count for userId:', userId);
        const response = await api.get(`${process.env.REACT_APP_API_BASE_URL}/orders/count?userId=${userId}`);
        console.log('Order count response:', response.data);
        const orderCount = response.data.count || 0;
        console.log('Order count:', orderCount);
        setIsNewCustomer(orderCount === 0);
        console.log('isNewCustomer set to:', orderCount === 0);
      } catch (error) {
        console.error("Error checking order count:", error);
        setIsNewCustomer(false);
      }
    };

    checkIfNewCustomer();
  }, [userId]);


  useEffect(() => {
    const convertGrandTotalToUSD = () => {
      try {
        const converted = convertToUSD(currency, grandTotal); // Use your utility
        setGrandTotalInUSD(converted);
      } catch (error) {
        console.error("Error converting grand total to USD:", error);
      }
    };

    convertGrandTotalToUSD();
  }, [grandTotal, currency]); // Re-run whenever grandTotal or currency changes


  return (
    <>

      <ToastContainer position="top-center" autoClose={3000} hideProgressBar={false} closeOnClick pauseOnHover draggable />

      <section
        className="min-h-screen bg-cover bg-center text-white font-inter lg:py-10 lg:px-4 sm:px-6 "
        style={{ backgroundImage: `url(${checkoutBg})` }}
      >

        {/* Back Button */}
        <div className="hidden lg:block">

          <button
            className="text-primary font-bold flex items-center mb-6"
            onClick={() => window.location.reload()} // Reloads the page
          >
            <i className="fas fa-arrow-left mr-2"></i> Back
          </button>
          {/* Page Title */}
          <div className="text-center mb-10">
            <h1
              className="text-3xl md:text-6xl lg:text-6xl font-monument font-extrabold text-primary text-center"
              style={{ fontFamily: "", fontWeight: 800 }}
            >
              CHECKOUT
            </h1>
            <div className="flex justify-center">
              <img src={downArrow} alt="Arrow Down" className=" mb-2 mt-3" />
            </div>
          </div>
        </div>


       <form
          onSubmit={(e) => {
            e.preventDefault(); // This prevents the form from submitting on any enter key or other default behaviors
          }}
          className="bg-[#191919] text-white px-10 lg:hidden"
        >          <button
            className="text-primary font-bold flex items-center mb-6"
            onClick={() => window.location.reload()} // Reloads the page
          >
            <i className="fas fa-arrow-left mr-2"></i> Back
          </button>
          {/* Page Title */}
          <div className="text-center mb-10">
            <h1
              className="text-3xl md:text-6xl lg:text-6xl font-monument font-extrabold text-primary text-center"
              style={{ fontFamily: "", fontWeight: 800 }}
            >
              CHECKOUT
            </h1>
            <div className="flex justify-center">
              <img src={downArrow} alt="Arrow Down" className=" mb-2 mt-3" />
            </div>
          </div>

          <div className="flex items-center gap-6 mb-6 font-inter" style={{ fontSize: '15px' }}>
            <img src={XboxBuy} className="w-[106px]" alt="Xbox Logo" />

            <div>
              <h1 className="text-primary text-lg font-bold">PS Coins</h1>
              <p className="text-primary mt-3">Quantity: {quantity}K</p>

              {/* Price + Bonus in same line */}
              <div className="flex items-center gap-3 mt-2">
                <div
                  className="flex items-center py-1 px-2 bg-primary rounded-lg shadow-md border border-primary font-bold"

                >
                  <span className="text-black">${amount.toFixed(2)}</span>
                </div>

                <div
                  className="flex items-center py-1 px-2 rounded-lg shadow-md border border-blue-400"
                  style={{ background: "linear-gradient(to right, #FFFFFF, #02BBFF)" }}
                >
                  <img
                    src={giftemoji}
                    alt="Bonus Icon"
                    className="w-6 h-6 mr-1"
                  />
                  <span className="text-black mr-6 font-inter text-sm font-bold italic whitespace-nowrap">
                    +{quantity * 0.1}K Coins
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="h-px w-screen bg-primary mb-4 mt-2 -mx-10"></div>

          <div className="border-t border-gray-800 my-4 font-inter" style={{ fontSize: '15px' }}></div>

          <div className="space-y-4 mb-6 font-inter" style={{ fontSize: '15px' }}>
            {!authToken && (
              <div>
                <label className="block mb-2">Contact Email</label>
                <input
                  type="email"
                  name="contactEmail"
                  value={formData.contactEmail}
                  onChange={handleInputChange}
                  required
                  className="w-full bg-transparent border border-primary rounded p-3 text-white"
                  style={{ fontSize: '15px' }}
                />
              </div>
            )}

            <div>
              <label className="block mb-2">Origin Email</label>
              <input
                type="email"
                name="originEmail"
                value={formData.originEmail}
                onChange={handleInputChange}
                required
                className="w-full bg-transparent border border-primary rounded p-3 text-white"
                style={{ fontSize: '15px' }}
              />
            </div>

            <div>
              <label className="block mb-2">Origin Password</label>
              <input
                type="password"
                name="originPassword"
                value={formData.originPassword}
                onChange={handleInputChange}
                required
                className="w-full bg-transparent border border-primary rounded p-3 text-white"
                style={{ fontSize: '15px' }}
              />
            </div>

            <div>
              <div className="flex justify-between mb-2">
                <label htmlFor="backupCode1">Backup Code</label>
                <div className="relative">
                  <button
                    onClick={() => setIsTooltipVisible(!isTooltipVisible)}
                    className="focus:outline-none"
                  >
                    <Info className="h-5 w-5 text-primary cursor-pointer" />
                  </button>
                  {isTooltipVisible && (
                    <div className="absolute right-0 z-10 w-64 p-3 mt-2 bg-primary text-black rounded-md shadow-lg">
                      <p className="text-sm">
                        <span className="font-bold">How to find backup codes:</span><br />
                        1. Go to <span className="underline">myaccount.ea.com</span><br />
                        2. Navigate to <span className="underline">Security and Privacy</span><br />
                        3. Select <span className="underline">Two Factor Authentication</span><br />
                        4. Click on <span className="underline">Backup codes</span>
                      </p>
                    </div>
                  )}
                </div>
              </div>
              <input
                type="text"
                id="backupCode1"
                name="backupCode1"
                value={formData.backupCode1}
                onChange={handleInputChange}
                required
                minLength="8"
                maxLength="8"
                className="w-full bg-transparent border border-primary rounded p-3 text-white"
              />
              {formData.backupCode1?.length > 0 && formData.backupCode1?.length < 8 && (
                <p className="text-red-500 text-sm mt-1">Backup codes must be at least 8 digits long.</p>
              )}
            </div>
          </div>

          <div className="bg-primary rounded-md p-3 mb-6 flex items-center gap-2 font-inter" style={{ fontSize: '15px' }}>
            <input
              type="checkbox"
              id="saveDetails"
              checked={saveDetails}
              onChange={() => setSaveDetails(!saveDetails)}
              className="h-5 w-5 rounded"
            />
            <label htmlFor="saveDetails" className="text-black">
              Save Details for Future Use
            </label>
          </div>

          <div className="flex mb-6 font-inter" style={{ fontSize: '15px' }}>
            <input
              type="text"
              placeholder="Discount Code"
              name="discountCode"
              value={formData.discountCode}
              onChange={handleInputChange}
              disabled={isDiscountApplied}
              className="flex-1 bg-transparent text-white rounded-l-md p-3 border border-primary/30"
              style={{ fontSize: '15px' }}
            />
            <button
              className="bg-primary text-black font-medium px-4 py-2 rounded-r-md border border-primary/30"
              onClick={handleDiscountApply}
              disabled={isDiscountApplied}
              style={{ fontSize: '15px' }}
            >
              Apply
            </button>
          </div>

          <div className="space-y-2 mb-6 font-inter" style={{ fontSize: '15px' }}>
            <div className="flex justify-between">
              <span>Subtotal:</span>
              <span>{currencySymbol}{amount.toFixed(2)}</span>
            </div>
            <div className="flex justify-between">
              <span>Discount:</span>
              <span>(-{currencySymbol}{discount.toFixed(2)})</span>
            </div>
            {!userId && (
              <div className="flex justify-between text-red-500">
                <span>Cashback Missed:</span>
                <span>({currencySymbol}{Number(cashback).toFixed(2)})</span>
              </div>
            )}

            <div className="flex items-center justify-between py-3 mb-4 border-b border-gray-800">
              <div className="flex items-center gap-3">
                <span className="text-white text-md">Wallet</span>

                {walletAmount > 0 ? (
                  <button
                    onClick={() => {
                      const usableWallet = Math.min(amount * 0.10, walletAmount);
                      setWalletEnabled(!walletEnabled);
                      setFormData((prevData) => ({
                        ...prevData,
                        walletUsed: !walletEnabled ? usableWallet : 0,
                      }));
                      setGrandTotal((prevTotal) =>
                        !walletEnabled ? prevTotal - usableWallet : prevTotal + formData.walletUsed
                      );
                    }}
                    className={`w-8 h-4 ${walletEnabled ? "bg-[#02BBFF]" : "bg-gray-600"} rounded-full relative transition-colors duration-300`}
                  >
                    <div
                      className={`absolute top-1 w-2 h-2 bg-white rounded-full transition-all duration-300 ${walletEnabled ? "right-1" : "left-1"}`}
                    ></div>
                  </button>
                ) : (
                  <span className="underline cursor-pointer text-gray-300" onClick={() => toggleRegisterPopup()}>
                    Sign up Required
                  </span>
                )}
              </div>

              {walletAmount > 0 && (
                <span className="text-white text-md">
                  -{currencySymbol}
                  {Math.min(amount * 0.10, walletAmount).toFixed(2)}
                </span>
              )}

            </div>
            <div className="flex justify-between font-bold text-lg">
              <span>Total:</span>
              <span className="text-[#02BBFF]">{currencySymbol}{grandTotal.toFixed(2)}</span>
            </div>
          </div>


          <div className="bg-primary rounded-md p-3 flex items-center gap-2">
            <input
              type="checkbox"
              id="agreeTerms"
              checked={agreeTerms}
              onChange={() => setAgreeTerms(!agreeTerms)}
              className="h-5 w-5 rounded"
            />
            <label htmlFor="agreeTerms" className="text-black text-[9px]">
              I agree to Futcoinspot's terms and conditions and privacy policy.
            </label>
          </div>

          <button
            type="submit"
            className="w-full bg-primary text-black font-bold py-3 rounded-lg hover:bg-yellow-300 transition mt-4"
            onClick={(e) => {
              e.preventDefault(); // Prevent default form submission

              if (!formData.contactEmail) {
                alert("Contact email is required.");
                return;
              }

              if (formData.backupCode1.length < 8) {
                alert("Backup code must exactly 8 digits long.");
                return;
              }

              handleSubmit(e); // Manually trigger submission
            }}
          >
            Buy
          </button>

        </form>

        {/* Main Content */}
        <form onSubmit={handleSubmit} className="hidden lg:grid grid-cols-1 lg:grid-cols-2 gap-8 mx-auto max-w-6xl">
          {/* Left Section */}
          <div className=" bg-transparent lg:border lg:border-primary lg:rounded-lg p-6">
            {/* Discount and Email */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 lg:mt-16">
              <div>
                <label className="block text-sm font-medium text-primary mb-2">Discount Code</label>
                <div className="flex">
                  <input
                    type="text"
                    name="discountCode"
                    value={formData.discountCode}
                    onChange={(e) =>
                      handleInputChange({
                        target: {
                          name: e.target.name,
                          value: e.target.value.toUpperCase(),
                        },
                      })
                    }
                    placeholder="Enter Discount Code"
                    disabled={isDiscountApplied}
                    className="bg-white border border-primary rounded-l-lg px-4 py-3 text-black focus:outline-none focus:ring focus:ring-primary w-full"
                  />
                  <button
                    type="button"
                    onClick={handleDiscountApply}
                    disabled={isDiscountApplied}
                    className="bg-primary text-black px-6 py-2 rounded-r-lg font-bold hover:bg-yellow-300 transition"
                  >
                    Apply
                  </button>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 mt-6 hidden">
                  <div>
                    <label className="block text-sm font-medium text-primary mb-2">Referral Code</label>
                    <div className="flex items-center space-x-4">
                      <input
                        type="text"
                        name="referralCode"
                        value={formData.referralCode}
                        onChange={handleInputChange}
                        placeholder="Enter Referral Code (if any)"
                        className="flex-grow bg-white border border-primary rounded-lg px-4 py-3 text-black focus:outline-none focus:ring focus:ring-primary"
                      />
                      <button
                        type="button"
                        onClick={() => validateReferralCode(formData.referralCode)}
                        className="px-4 py-2 bg-primary text-black rounded-lg hover:bg-yellow-500 transition"
                      >
                        Apply
                      </button>
                    </div>
                  </div>
                </div>



              </div>
              <div>
                <label className="block text-sm font-medium text-primary mb-2">Contact Email</label>
                <input
                  type="email"
                  name="contactEmail"
                  value={formData.contactEmail}
                  onChange={handleInputChange}
                  required
                  placeholder="Enter Contact Email"
                  className="bg-white border border-primary rounded-lg px-4 py-3 text-black focus:outline-none focus:ring focus:ring-primary w-full"
                />
              </div>
            </div>

            {/* Origin Email and Password */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 mt-6">
              <div>
                <label className="block text-sm font-medium text-primary mb-2">Origin Email</label>
                <input
                  type="email"
                  name="originEmail"
                  value={formData.originEmail}
                  onChange={handleInputChange}
                  required

                  placeholder="Enter Origin Email"
                  className="bg-white border border-primary rounded-lg px-4 py-3 text-black focus:outline-none focus:ring focus:ring-primary w-full"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-primary mb-2">Origin Password</label>
                <input
                  type="password"
                  name="originPassword"
                  value={formData.originPassword}
                  onChange={handleInputChange}
                  required

                  placeholder="Enter Origin Password"
                  className="bg-white border border-primary rounded-lg px-4 py-3 text-black focus:outline-none focus:ring focus:ring-primary w-full"
                />
              </div>
            </div>

            {/* Backup Codes */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 mt-6">
              <div className="relative">
                <label className="block text-sm font-medium text-primary mb-2 flex items-center">
                  Backup Code 1
                  <div className="ml-2 relative group">
                    <i className="fas fa-info-circle text-primary text-md p-1 cursor-pointer"></i>

                    <span className="absolute z-10 bg-primary text-black text-xs rounded-lg px-3 py-2 max-w-[250px] w-[90vw] sm:w-auto sm:max-w-xs -top-24 left-1/2 transform -translate-x-1/2 whitespace-normal opacity-0 group-hover:opacity-100 transition-opacity duration-300 shadow-lg text-center">
                      https://myaccount.ea.com → Security and Privacy → Two Factor Authentication → Backup codes
                    </span>
                  </div>

                </label>
                <input
                  type="text"
                  name="backupCode1"
                  value={formData.backupCode1}
                  onChange={handleInputChange}
                  maxLength="8"
                  placeholder="Enter Backup Code 1"
                  className="bg-white border border-primary rounded-lg px-4 py-3 text-black focus:outline-none focus:ring focus:ring-primary w-full"
                  required
                />
                {formData.backupCode1.length > 0 && formData.backupCode1.length < 8 && (
                  <p className="text-red-500 text-sm mt-1">BA's must be at least 8 digits long.</p>
                )}
              </div>


            </div>

            {/* Save Details Checkbox */}
            <div className="mt-6 bg-primary rounded-lg py-4 text-center">
              <label className="flex items-center justify-center space-x-2">
                <input
                  type="checkbox"
                  className="text-primary focus:ring focus:ring-primary"
                  checked={isSaveDetailsChecked}
                  onChange={handleSaveDetailsChange}
                />
                <span className="text-sm text-black font-medium">Save Details for Future Use</span>
              </label>
            </div>
          </div>


          {/* Right Section */}
          <div className="bg-transparent p-6">
            <div className="grid gap-2">
              {/* Quantity */}

              <div className="hidden md:flex items-center border border-[#02BBFF] rounded-lg overflow-hidden">
                <p className="bg-[#02BBFF] text-white px-4 py-4 font-bold w-1/3">Quantity</p>
                <div className="flex items-center flex-1 justify-end px-4 py-2">
                  <img src={PS2} alt="Origin Logo" className="mr-2" />
                  <p className="text-[#02BBFF] font-bold mr-4">{quantity}K</p>
                  <span className="text-lg text-blue-300 mr-4"> + </span>

                  <div
                    className="px-2 py-1 rounded-lg shadow-md border border-[#02BBFF] flex items-center justify-center text-xs sm:text-sm md:text-base"
                    style={{
                      background: "linear-gradient(to right, #FFFFFF, #00BBFF)",
                    }}
                  >
                    <img src={giftemoji} alt="Bonus Icon" className="w-5 h-5 sm:w-6 sm:h-6 mr-1 sm:mr-2" />
                    <span className="text-black font-inter text-[12px] font-bold italic whitespace-nowrap">
                      {quantity * 0.10}K Bonus
                    </span>
                  </div>
                </div>
              </div>





              {/* Amount */}
              <div className="flex items-center border border-primary rounded-lg overflow-hidden">
                <p className="bg-primary text-black px-4 py-2 font-bold w-1/3">Amount</p>
                <p className="flex-1 text-right text-primary px-4 py-2 mr-10">{currencySymbol}{amount.toFixed(2)}</p>
              </div>

              <div className="flex items-center border border-primary rounded-lg overflow-hidden hidden ">
                <p className="bg-primary text-black px-4 py-2 font-bold w-1/3">Gateway Fees +</p>
                <p className="flex-1 text-right text-primary px-4 py-2 mr-10">{currencySymbol}{gatewayFees.toFixed(2)}</p>
              </div>




              {/* Cashback */}
              <div className="flex items-center border border-primary rounded-lg relative">
                <p className="bg-primary text-black px-4 py-2 font-bold w-1/3 flex items-center">
                  Wallet
                  <i className="fas fa-info-circle text-black cursor-pointer ml-2 relative group">
                    {/* Tooltip */}
                    <span className="absolute font-inter font-bold hidden group-hover:block bg-primary text-black text-sm rounded-lg p-6 w-64 left-1/2 transform -translate-x-1/2 -top-[94px] z-10">
                      10% of the order value can be used from wallet
                    </span>
                  </i>
                </p>

                <div className="flex-1 flex justify-end items-center px-4 py-2">
                  {walletAmount > 0 ? (
                    <>
                      <label className="relative inline-flex items-center cursor-pointer">
                        <input
                          type="checkbox"
                          className="sr-only peer"
                          onChange={() => {
                            const usableWallet = Math.min(amount * 0.10, walletAmount);
                            setIsCashbackEnabled(!isCashbackEnabled);
                            setFormData((prevData) => ({
                              ...prevData,
                              walletUsed: !isCashbackEnabled ? usableWallet : 0,
                            }));
                            setGrandTotal((prevTotal) =>
                              !isCashbackEnabled ? prevTotal - usableWallet : prevTotal + formData.walletUsed
                            );
                          }}
                          checked={isCashbackEnabled}
                        />
                        <div className="w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-2 peer-focus:ring-primary peer-checked:after:translate-x-6 peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary"></div>
                      </label>
                      <span className="ml-2 text-primary mr-10">
                        {isCashbackEnabled
                          ? ""
                          : `- ${currencySymbol}${Math.min(amount * 0.10, walletAmount).toFixed(2)}`}
                      </span>

                    </>
                  ) : (
                    <span
                      className="underline cursor-pointer text-gray-300"
                      onClick={() => toggleRegisterPopup()}
                    >
                      Sign up Required
                    </span>
                  )}
                </div>


              </div>





              {/* Discount Code */}
              <div className="flex items-center border border-primary rounded-lg overflow-hidden">
                <p className="bg-primary text-black px-4 py-2 font-bold w-1/3">Discount Code</p>
                <p className="flex-1 text-right text-primary px-4 py-2 mr-10">
                  - {currencySymbol}{discount.toFixed(2)} {/* Display the discount amount dynamically */}
                </p>
              </div>

              {/* Grand Total */}
              <div className="flex items-center border border-primary rounded-lg relative">
                <p className="bg-primary text-black px-4 py-2 font-bold w-1/3 flex items-center">
                  Grand Total
                  <span className="relative group">
                    <i className="fas fa-info-circle text-black cursor-pointer ml-2"></i>
                    <span className="bg-primary text-black text-xs rounded-lg p-3 absolute -top-14 left-1/2 transform -translate-x-1/3 whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-10 shadow-lg text-center">
                      All payments will be processed in USD
                      ($)<br />
                      (Total includes processing fee: {currencySymbol}{gatewayFees.toFixed(2)})
                    </span>
                  </span>
                </p>
                <p className="flex-1 text-right text-primary px-4 py-2 mr-10">
                  {currencySymbol}{grandTotal.toFixed(2)}
                </p>
              </div>



              <div className=" items-center border border-primary rounded-lg overflow-hidden hidden">
                <p className="bg-primary text-black px-4 py-2 font-bold w-1/3">Grand Total(USD)</p>
                <p className="flex-1 text-right text-primary px-4 py-2 mr-10">
                  $
                  {grandTotalInUSD.toFixed(2)}
                </p>
              </div>

              {/* Cashback Earned */}
              <CashbackComponent
                userId={userId}
                cashback={userId ? parseFloat(cashback).toFixed(2) : `${parseFloat(cashback).toFixed(2)}${currencySymbol}`}
                currencySymbol={currencySymbol}
              />



            </div>

            {/* Agreement */}
            <div className="mt-6 bg-primary rounded-lg py-4 text-center">
              <label className="flex items-center justify-center space-x-2">
                <input
                  type="checkbox"
                  className="text-primary focus:ring focus:ring-primary ml-2"
                />
                <span className="text-xs underline text-black font-medium">
                  I agree to Futcoinspot’s terms and conditions and privacy policy.
                </span>
              </label>
            </div>



            {/* Buy Button */}
            <button
              type="submit"
              className="w-full bg-primary text-black font-bold py-3 rounded-lg hover:bg-yellow-300 transition mt-4"
            >
              Buy
            </button>
            {/* <button
              type="submit"
              onClick={handleCheckout}
              className="w-full bg-primary text-black font-bold py-3 rounded-lg hover:bg-yellow-300 transition mt-4"
            >
              Buy
            </button> */}

          </div>
        </form>
      </section>

      {showLoginPopup && <Login onClose={toggleLoginPopup} />}
      {showRegisterPopup && <Register onClose={toggleRegisterPopup} showLogin={toggleLoginPopup} />}
    </>
  );
};

export default PSCheckout;